import axios from "axios";
import { ProductStock } from "../../utils/getData/ProductStock";
import { useManagementNotice } from "./ManagementNotice";

const apiUrl = process.env.REACT_APP_BACKEND_API_URL;

interface ProductItemProps {
  productValiation: ProductStock;
  team: string;
  productCode: string;
  isSale: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  fetchProductStockData: (productCode: string) => Promise<void>;
}

export const ProductItem = ({ productValiation, team, productCode, isSale, setLoading, fetchProductStockData }: ProductItemProps) => {

  const { notifySuccess, notifyError } = useManagementNotice();
  const imgSrc =`/image/${team}/${productCode}/${String(productValiation.id).padStart(8, '0')}.jpg`;

  const updateStock = async (event: React.FocusEvent<HTMLInputElement>) => {
    const variationId = event.target.name;
    const newStock = event.target.value;
    // フォーカスが外れただけで値が変わっていない場合は API を叩かない(通知も出さない)
    if (newStock === String(productValiation.stock)) {
      return;
    }
    setLoading(true);
    try {
      const postData = { variation_id: variationId, stock: newStock };
      await axios.post(`${apiUrl}/maintenance/updateProductStock/`, postData, { withCredentials: true });
      await fetchProductStockData(productCode);
      setLoading(false);
      notifySuccess(`カードID：${variationId} の在庫数の更新に成功しました。`);
    } catch {
      // ローディング解除で一覧が再描画され、入力欄は更新前の在庫数に戻る
      setLoading(false);
      notifyError(`カードID：${variationId} の在庫数の更新に失敗しました。`);
    }
  };

  return (
    <div className={`text-center`} key={productValiation.id}>
      <img alt="" src={imgSrc} className={`${productValiation.is_deleted ? 'grayscale-100' : ''}`}/>
      {productValiation.is_deleted &&
        <p className="m-0 text-danger">
          販売停止中
        </p>
      }
      <p className="my-1">カードID：{productValiation.id} </p>
      <p className="my-1">{productValiation.rarity} {productValiation.name}</p>
      {/* 販売在庫管理タブ(所持数なし)では在庫数を編集できる。ユーザー所持数タブでは在庫数は表示のみ */}
      {productValiation.stock !== undefined && productValiation.possessions === undefined &&
        <p className="mx-2 my-1 d-flex align-items-center">
          在庫数：
          <input className="form-control col" type="number" name={String(productValiation.id)} defaultValue={productValiation.stock} onBlur={updateStock} disabled={isSale} />
        </p>
      }
      {productValiation.possessions !== undefined &&
        <>
          <p className="my-1">
            ユーザー所持数：{productValiation.possessions}
          </p>
          <p>
            在庫数：{productValiation.stock}
          </p>
        </>
      }
    </div>
  );
};